import { Link } from 'react-router-dom';
import { HowItWorksFlow } from '../components/HowItWorksFlow';
import './featurePage.css';
import './ProcessControlPage.css';

export function ProcessControlPage() {
  return (
    <div className="page">
      {/* Hero — tech-style banner */}
      <section className="pc-hero">
        <div className="pc-hero__grid" aria-hidden />
        <div className="pc-hero__content">
          <span className="pc-hero__pill">
            SQM Next-Generation Intelligent Quality System
          </span>
          <h1 className="pc-hero__title">
            <span className="pc-hero__brand">DAP-AI</span>: Process Control
            System
          </h1>
          <p className="pc-hero__subtitle">
            Real-time AI-driven quality monitoring that predicts and prevents
            defects before they occur — enabling scalable intelligent
            manufacturing across your supply chain.
          </p>
          <div className="pc-hero__stats">
            <div className="pc-hero__stat">
              <div className="pc-hero__stat-value">IQC · IPQC · OQC</div>
              <div className="pc-hero__stat-label">Full Inspection Coverage</div>
            </div>
            <div className="pc-hero__stat">
              <div className="pc-hero__stat-value">Zero Cost</div>
              <div className="pc-hero__stat-label">Incremental Deployment</div>
            </div>
            <div className="pc-hero__stat">
              <div className="pc-hero__stat-value">Self-Learning</div>
              <div className="pc-hero__stat-label">Knowledge Base</div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <HowItWorksFlow className="pc-howitworks" />

      {/* Launch */}
      <Link className="pc-launch" to="/portal/supplier-process-control/system">
        <span className="pc-launch__btn">🏭 Launch Process Control System</span>
        <span className="pc-launch__note">
          Enter the DAP-AI Process Control System
        </span>
      </Link>
    </div>
  );
}
